const BASE_URL = '/api/v1/guest'
const MAIL_LOGIN_BASE_URL = '/api/mail-login'

const request = async (url, method = 'GET', data = {}) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
  }
  
  if (method !== 'GET') {
    options.body = JSON.stringify(data)
  }
  
  try {
    const response = await fetch(`${BASE_URL}${url}`, options)
    return await response.json()
  } catch (error) {
    return {
      code: 500,
      data: null,
      message: '网络请求失败'
    }
  }
}

export const validateCard = async (cardCode) => {
  return await request('/cards/validate', 'POST', { cardCode })
}

export const validateToken = async (token) => {
  return await request('/tokens/validate', 'POST', { token })
}

export const createOrder = async (cardCode, token) => {
  let orderToken = token

  if (typeof token === 'string') {
    try {
      const parsedToken = JSON.parse(token)

      if (parsedToken && typeof parsedToken === 'object' && !Array.isArray(parsedToken)) {
        delete parsedToken.marketingEligibility
        orderToken = JSON.stringify(parsedToken)
      }
    } catch (error) {
      // Keep the original value; token validation handles malformed input.
    }
  }

  return await request('/orders', 'POST', { cardCode, token: orderToken })
}

export const queryOrdersByCards = async (cardCodes) => {
  return await request('/orders/query-by-card', 'POST', { cardCodes })
}

export const queryOrderByCard = async (cardCode) => {
  const response = await queryOrdersByCards([cardCode])

  if (response.code !== 200) {
    return response
  }

  const queryRecords = Array.isArray(response.data)
    ? response.data
    : (
        response.data?.records ||
        response.data?.results ||
        response.data?.items ||
        response.data?.orders ||
        response.data?.list ||
        response.data?.orderList ||
        []
      )
  const result = Array.isArray(queryRecords) ? queryRecords[0] : null

  if (!result || result.found === false) {
    return {
      code: 404,
      data: result,
      message: (result && result.message) || '未找到订单'
    }
  }

  return {
    ...response,
    data: result
  }
}

export const exchangeCards = async (cardCodes, password) => {
  return await request('/cards/exchange', 'POST', { cardCodes, password })
}

const mailLoginRequest = async (url, method = 'GET', data = null, token = '') => {
  const options = {
    method,
    headers: {}
  }

  if (token) {
    options.headers['X-Task-Token'] = token
  }

  if (data !== null) {
    options.headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(data)
  }

  try {
    const response = await fetch(`${MAIL_LOGIN_BASE_URL}${url}`, options)
    const result = await response.json()

    if (result && result.code === 404 && result.message === '接口不存在') {
      return {
        ok: false,
        httpStatus: response.status,
        error: '账密登录服务代理未配置或未生效'
      }
    }

    return {
      httpStatus: response.status,
      ...result
    }
  } catch (error) {
    return {
      ok: false,
      httpStatus: 500,
      error: '账密登录服务请求失败'
    }
  }
}

export const createMailLoginTask = async ({ email, mailPassword, gptPassword }) => {
  return await mailLoginRequest('/tasks', 'POST', {
    email,
    mail_password: mailPassword,
    gpt_password: gptPassword
  })
}

export const queryMailLoginTask = async (taskId, pollToken) => {
  return await mailLoginRequest(`/tasks/${taskId}`, 'GET', null, pollToken)
}

export const deleteMailLoginTask = async (taskId, pollToken) => {
  return await mailLoginRequest(`/tasks/${taskId}`, 'DELETE', null, pollToken)
}
